<template>
  <v-container fluid>
    <v-app-bar dark app color="primary">
      <v-app-bar-nav-icon>
        <v-icon>mdi-laptop</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>BYOD-Beiträge</v-toolbar-title>

      <v-spacer />
      <SearchField v-model="search"></SearchField>
    </v-app-bar>
    <v-card :loading="loading" class="mt-4">
      <v-system-bar dark>Eingereicht BYOD-Beiträge</v-system-bar>
      <v-data-table
        :headers="headers"
        :items="itemsFiltered"
        @click:row="(item) => show(item)"
        :item-class="() => 'clickable'"
      >
        <template v-slot:item.number="{ item }">
          {{ item.number }}
          <div class="mt-n1 text--disabled" v-if="item.group">
            {{ item.group.number }}
          </div>
        </template>
        <template v-slot:item.employee="{ item }">
          <PersonItem small v-if="item.employee" :value="item.employee" />
          <div v-else>
            <v-chip outlined>
              <v-avatar left
                ><v-img :src="require('@/assets/icon.png')" alt="Schulfonds"
              /></v-avatar>
              Schulfonds
            </v-chip>
          </div>
        </template>
        <template v-slot:item.date="{ item }">
          <DateValue :value="item.date" />
        </template>
        <template v-slot:item.enterDate="{ item }">
          <DateValue :value="item.enterDate" />
        </template>
        <template v-slot:item.amount="{ item }">
          <CurrencyValue v-if="item.amount" :value="item.amount" />
          <span class="text--disabled" v-else>CHF ?.??</span>
        </template>
      </v-data-table>
    </v-card>

    <v-card class="mt-12">
      <v-system-bar dark> Neuen BYOD-Beitrag erfassen </v-system-bar>

      <v-toolbar flat>
        <PersonInput
          hideDetails
          group="staff"
          v-model="person"
          class="mr-2"
          clearable
        />
        <v-text-field
          :disabled="!person"
          hideDetails
          v-model="iban"
          label="IBAN"
          :rules="[validIban]"
        >
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="creating"
          outlined
          @click="create"
          :disabled="!canCreate"
          >Erzeugen</v-btn
        >
      </v-toolbar>
    </v-card>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import SearchField from "@/components/SearchField.vue";
import PersonInput from "common/components/PersonInput.vue";
import CurrencyValue from "common/components/CurrencyValue.vue";
import DateValue from "common/components/DateValue.vue";
import PersonItem from "common/components/PersonItem.vue";
import { searchPerson } from "common/utils/people.js";

import { isValidIBANNumber } from "common/utils/finance.js";

export default defineComponent({
  name: "FinanceByod",
  components: {
    SearchField,
    PersonInput,
    CurrencyValue,
    DateValue,
    PersonItem,
  },
  data() {
    return {
      search: null,
      person: null,
      iban: null,
      items: [],
      loading: false,
      creating: false,

      validIban: (value) => {
        return isValidIBANNumber(value) || "Ungültige IBAN.";
      },
      headers: [
        { text: "Nummer", value: "number" },
        { text: "Datum", value: "date" },
        { text: "Buchung", value: "enterDate" },
        { text: "Mitarbeiter:in", value: "employee" },
        { text: "Anlass", value: "event" },
        { text: "Beschreibung", value: "description" },
        { text: "Betrag", value: "amount", align: "end" },
      ],
    };
  },
  computed: {
    itemsFiltered() {
      if (!this.search) {
        return this.items;
      }
      return this.items.filter(
        (item) =>
          item.number.toLowerCase() == this.search.toLowerCase() ||
          searchPerson(item.employee, this.search.toLowerCase())
      );
    },
    canCreate() {
      if (!this.person) {
        return;
      }
      if (!this.iban) {
        return;
      }
      if (!isValidIBANNumber(this.iban)) {
        return;
      }
      return true;
    },
  },
  watch: {
    person() {
      this.iban = null;
    },
  },
  methods: {
    async create() {
      this.creating = true;
      await this.apiPost({
        resource: "finance/byod",
        data: {
          employee: this.person.id,
          iban: this.iban,
        },
      });
      this.creating = false;
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/byod",
      });
      this.loading = false;
    },
    show(item) {
      this.$router.push(
        `/financeInvoices/${item.status.code}/detail/${item.id}`
      );
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
